import React, { useMemo } from 'react';

import { observer } from 'mobx-react';
import { angularize } from 'react-in-angularjs';
import { ProductFruits } from 'react-product-fruits';

import { loggedInUserDataStore } from '../../../shared/stores/loggedInUserDataStore';
import { solutionsStore } from '../../../shared/stores/solutionsStore';

const WORKSPACE_CODE = '4K0wcRa6iiWGonWQ';
const APP_ENV = process.env.APP_ENV as string;
// explicit value for "not applicable / not loaded" so PM can target it in segments
const NONE = 'NONE';

const NgzProductFruitInit = observer(() => {
  const { loggedInUser, systemPaymentInfo } = loggedInUserDataStore;
  const { id, email, firstName, lastName, role, entityType } = loggedInUser ?? {};
  const { paymentFlowType, billingType, scanIqBillingType } = systemPaymentInfo;
  const solutions = solutionsStore.availableSolutions.join('&') || NONE;

  // stable reference: ProductFruits pushes updateUserData on every new `user` object
  const userInfo = useMemo(
    () => ({
      username: email ?? '',
      email,
      firstname: firstName,
      lastname: lastName,
      role,
      props: {
        env: APP_ENV,
        entityType: entityType ?? NONE,
        paymentFlowType: paymentFlowType ?? NONE,
        billingType: billingType ?? NONE,
        scanIqBillingType: scanIqBillingType ?? NONE,
        solutions,
      },
    }),
    [
      email,
      firstName,
      lastName,
      role,
      entityType,
      paymentFlowType,
      billingType,
      scanIqBillingType,
      solutions,
    ],
  );

  if (!id) {
    return null;
  }

  return (
    <ProductFruits
      workspaceCode={WORKSPACE_CODE}
      language="en"
      user={userInfo}
      lifeCycle="unmount"
    />
  );
});

angularize(NgzProductFruitInit, 'ngzProductFruitInit', angular.module('app'), {});

export { NgzProductFruitInit };
